import {
    Chip,
    EmailAPIFactory,
    EmptyContent,
    GenericWrapperContext,
    Header,
    Icon,
    LoadingContainer,
    MetricCard,
    TEmailReport
} from "@cakemail-org/ui-components-v2"
import { affixToPercent, returnEmailTagsQuery, returnProviderQuery } from "../../../../../utils/data"
import { getComparedReportStat } from "../../../../../utils/components"
import { emptyReportLog } from "../../../../../data/emailAPI"
import { getAPIDateRange } from "../../../../../utils/date"
import { LastXDays } from "../../../../../components/lastXDays"
import { useTranslation } from "react-i18next"
import { useContext, useEffect, useState } from "react"
import { Box, Grid, Stack } from "@mui/material"
import { MetricCardsContainer } from "../../../../../components/contentTemplate/metricCardsContainer"

//TODO waiting for New filer for providers

export function KeyReputationMetrics({ timeRange, tagsFilter, providerFilter, controlled, controlledProps, filterOperator, refreshKey }: TKeyReputationMetrics) {
    const { t } = useTranslation()
    const genericWrapper = useContext(GenericWrapperContext)

    const [stateMetrics, setStateMetrics] = useState<TEmailReport>()
    const [stateOldMetrics, setStateOldMetrics] = useState<TEmailReport>()
    const [stateLoading, setStateLoading] = useState<boolean>(true)
    const [stateError, setStateError] = useState<boolean>(false)

    let loading: boolean = false
    let error: boolean = false
    let metrics: TEmailReport | undefined = undefined
    let oldMetrics: TEmailReport | undefined = undefined

    // To aliviate multiple same component on a page, will minimize the ammount of api call. 
    // You cannot change the controlled property afterwards
    if (controlled) {
        metrics = controlledProps?.metrics
        oldMetrics = controlledProps?.oldMetrics
        loading = controlledProps?.loading || false
        error = controlledProps?.error || false
    } else {
        useEffect(fetchMetrics, [timeRange, tagsFilter, providerFilter, refreshKey])
        metrics = stateMetrics
        oldMetrics = stateOldMetrics
        loading = stateLoading
        error = stateError
    }

    function fetchMetrics() {
        setStateLoading(true)
        const apiTimeRange = getAPIDateRange({ range: timeRange })
        const p1 = EmailAPIFactory.getReport({
            providers: returnProviderQuery({ providers: providerFilter, operator: filterOperator }),
            tags: returnEmailTagsQuery(tagsFilter, { operator: filterOperator }),
            startTime: apiTimeRange.start,
            endTime: apiTimeRange.end,
        }).then((data) => {
            setStateError(false)
            setStateMetrics(data[0] || emptyReportLog)
        }).catch(() => {
            setStateError(true)
        })

        const apiTimeRangeDouble = getAPIDateRange({ range: timeRange, rangeMultiplier: 2 })
        const p2 = EmailAPIFactory.getReport({
            providers: returnProviderQuery({ providers: providerFilter, operator: filterOperator }),
            tags: returnEmailTagsQuery(tagsFilter, { operator: filterOperator }),
            startTime: apiTimeRangeDouble.start,
            endTime: apiTimeRangeDouble.end,
        }).then((data) => {
            setStateOldMetrics(data[0])
        })

        Promise.allSettled([p1, p2]).then((data) => {
            setStateLoading(false)
        })

    }

    const compairedDelivery = getComparedReportStat({ metrics: metrics, oldMetrics: oldMetrics, stat: "delivery_rate", isRate: true })
    const comparedBounce = getComparedReportStat({ metrics: metrics, oldMetrics: oldMetrics, stat: "bounce_rate", isRate: true, reverse: true })
    const comparedUnsub = getComparedReportStat({ metrics: metrics, oldMetrics: oldMetrics, stat: "unsubscribe_rate", isRate: true, reverse: true })
    const compairedSpam = getComparedReportStat({ metrics: metrics, oldMetrics: oldMetrics, stat: "spam_rate", isRate: true, reverse: true })

    const apiTimeRange = getAPIDateRange({ range: timeRange })

    const vsString = <LastXDays apiTimeRange={apiTimeRange} removeLastX addPreviousText />

    return <Stack className="analyticBlock keyReputationMetrics">
        <Header
            heading={t("header-key-reputation-metrics-heading")}
            postHeading={<LastXDays apiTimeRange={apiTimeRange} />}
            headingTooltip={t("header-key-reputation-metrics-heading")}
        />

        <LoadingContainer loading={!metrics && !error} variant="linear">
            <MetricCardsContainer loading={loading}>
                {metrics &&
                    <>
                        {/**<Grid item>
                            <MetricCard
                                className="withProgress"
                                heading={{
                                    iconName: "Sends24",
                                    name: t("general-sender-reputation"),
                                    tooltip: t("general-sender-reputation-tooltip")
                                }}
                                subHeading={{
                                    data:  affixToPercent(metrics.delivery_rate, genericWrapper.user?.language) + "%",
                                    linearProgress: {
                                        value: metrics.delivery_rate,// TODO NEED DELIVERY STAT
                                        color: "secondary"
                                    }
                                }}
                                floatingRow={<Stack>
                                    <Typography color="secondary.main" variant='headlineS'>{t("general-txt-rate-good")} (90+)</Typography>
                                    <Typography>{t("email-delivery-reputation-desc")}</Typography>
                                </Stack>}
                            />
                                </Grid>**/}
                        <Grid item>
                            <MetricCard
                                heading={{
                                    iconName: "Completed24",
                                    name: t("general-delivery_rate"),
                                    tooltip: t("general-delivery_rate-tooltip")
                                }}
                                subHeading={{
                                    data: affixToPercent(metrics?.delivery_rate, genericWrapper.user?.language)
                                }}
                                floatingRow={<Box>
                                    <Chip
                                        variant="outlined"
                                        color={compairedDelivery?.color || "body1"}
                                        icon={compairedDelivery?.icon && <Icon name={compairedDelivery.icon} />}
                                        label={compairedDelivery?.value || "0%"}
                                    />
                                    {vsString}
                                </Box>}
                            />
                        </Grid>
                        <Grid item>
                            <MetricCard
                                heading={{
                                    iconName: "Bounce24",
                                    name: t("general-bounce_rate"),
                                    tooltip: t("general-bounce_rate-tooltip")
                                }}
                                subHeading={{
                                    data: affixToPercent(metrics.bounce_rate, genericWrapper.user?.language),
                                }}
                                floatingRow={<Box>
                                    <Chip
                                        variant="outlined"
                                        color={comparedBounce?.color || "body1"}
                                        icon={comparedBounce?.icon && <Icon name={comparedBounce.icon} />}
                                        label={comparedBounce?.value || "0%"}
                                    />
                                    {vsString}
                                </Box>}
                            />
                        </Grid>
                        <Grid item>
                            <MetricCard
                                heading={{
                                    iconName: "Unsubscribes24",
                                    name: t("general-unsubscribe_rate"),
                                    tooltip: t("general-unsubscribe_rate-tooltip")
                                }}
                                subHeading={{
                                    data: affixToPercent(metrics.unsubscribe_rate, genericWrapper.user?.language),
                                }}
                                floatingRow={<Box>
                                    <Chip
                                        variant="outlined"
                                        color={comparedUnsub?.color || "body1"}
                                        icon={comparedUnsub?.icon && <Icon name={comparedUnsub.icon} />}
                                        label={comparedUnsub?.value || "0%"}
                                    />
                                    {vsString}
                                </Box>}
                            />
                        </Grid>
                        <Grid item>
                            <MetricCard
                                heading={{
                                    iconName: "Flag24",
                                    name: t("general-spam_rate"),
                                    tooltip: t("general-spam_rate-tooltip")
                                }}
                                subHeading={{
                                    data: affixToPercent(metrics.spam_rate, genericWrapper.user?.language),
                                }}
                                floatingRow={<Box>
                                    <Chip
                                        variant="outlined"
                                        color={compairedSpam?.color || "body1"}
                                        icon={compairedSpam?.icon && <Icon name={compairedSpam.icon} />}
                                        label={compairedSpam?.value || "0%"}
                                    />
                                    {vsString}
                                </Box>}
                            />
                        </Grid>
                    </>
                }
                {error && <EmptyContent
                    title={t("analytic-block-loading-error-title")}
                />}
            </MetricCardsContainer>
        </LoadingContainer>
    </Stack >
}
